export enum TripFinishedStatusEnum {
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
    CLOSED = 'CLOSED',
}
